import React, { useState } from 'react';
import GamesCollectionSection from './games/components/GamesCollectionSection';
import GamesCtaSection from './games/components/GamesCtaSection';
import GamesExplorationsSection from './games/components/GamesExplorationsSection';
import GamesHeroSection from './games/components/GamesHeroSection';
import GamesMoviesModal from './games/components/GamesMoviesModal';
import GamesMoviesSection from './games/components/GamesMoviesSection';
import GamesNotesSection from './games/components/GamesNotesSection';
import GamesPrinciplesSection from './games/components/GamesPrinciplesSection';
import {
  API_EXPLORATIONS,
  GAMES,
  GAMES_NOTES,
  GAMES_PRINCIPLES,
  MOVIES_MODAL_COLUMNS,
} from './games/constants';

const Games = () => {
  const [isMoviesModalOpen, setIsMoviesModalOpen] = useState(false);

  const handleOpenMoviesModal = () => {
    setIsMoviesModalOpen(true);
  };

  const handleCloseMoviesModal = () => {
    setIsMoviesModalOpen(false);
  };

  return (
    <>
      <GamesHeroSection />

      <div className="site-bg-section py-20 px-6">
        <div className="container mx-auto">
          <GamesCollectionSection games={GAMES} />
          <GamesExplorationsSection explorations={API_EXPLORATIONS} />
          <GamesMoviesSection onOpenModal={handleOpenMoviesModal} />
          <GamesPrinciplesSection principles={GAMES_PRINCIPLES} />
          <GamesNotesSection notes={GAMES_NOTES} />
          <GamesCtaSection />
        </div>
      </div>

      <GamesMoviesModal
        isOpen={isMoviesModalOpen}
        movieColumns={MOVIES_MODAL_COLUMNS}
        onClose={handleCloseMoviesModal}
      />
    </>
  );
};

export default Games;
